export const ANONYMOUS_PRESENCE_DWELL_MS = 5_000
export const ANONYMOUS_PRESENCE_VISIBLE_RATIO = 0.4
export const ANONYMOUS_PRESENCE_VISIBLE_PIXELS = 240

export function qualifiesAnonymousPresence(
    isIntersecting: boolean,
    intersectionRatio: number,
    visibleHeight: number,
): boolean {
    return (
        isIntersecting &&
        (intersectionRatio >= ANONYMOUS_PRESENCE_VISIBLE_RATIO ||
            visibleHeight >= ANONYMOUS_PRESENCE_VISIBLE_PIXELS)
    )
}

export function anonymousPresenceThresholdForHeight(height: number): number {
    if (!Number.isFinite(height) || height <= 0) return ANONYMOUS_PRESENCE_VISIBLE_RATIO

    return Math.min(ANONYMOUS_PRESENCE_VISIBLE_RATIO, ANONYMOUS_PRESENCE_VISIBLE_PIXELS / height)
}

export function anonymousPresenceResultIsTerminal(result?: string | null): boolean {
    return new Set([
        'rewarded_pending',
        'tracked_shadow',
        'already_seen',
        'first_seen_organic',
        'authenticated',
        'not_rewarded',
        'cap_reached',
        'campaign_disabled',
        'cookies_required',
    ]).has(result || '')
}
